import { Injectable } from '@angular/core';
import { TokenDecoded, UserToken } from '@interfaces/core/token.interface';
import { TokenHandler } from '@services/token-handler.service';

@Injectable()
export class AuthTokenHandler extends TokenHandler {
  public run(accessToken: string): UserToken {
    const tokenDecoded = this.parseJWT(accessToken);

    const token = this.processTokens(accessToken, tokenDecoded);

    return {
      token,
      tokenDecoded: tokenDecoded as TokenDecoded,
    };
  }
}
